// Scan modules.
//
// The backend accepts seven module ids. The design groups them into four, which is a
// presentation change rather than a scan change, so this file holds both: the UI
// offers four toggles and the payload still sends the ids the scanner understands.
//
// Doing it the other way — sending four new ids — would need new module handlers, new
// result categories, and a migration for every stored scan. This gets the designed
// screen with no backend work and no divergence from what the API accepts.
export const MODULE_GROUPS = [
  { key: "security",   label: "Security",         ids: ["email", "ssl", "headers"],
    hint: "Email authentication, certificates and security headers" },
  { key: "exposure",   label: "Exposure",         ids: ["breach", "dns"],
    hint: "Breach intelligence and DNS configuration" },
  { key: "infra",      label: "Infrastructure",   ids: ["infra"],
    hint: "Hosting and origin exposure" },
  { key: "brand",      label: "Brand Protection", ids: ["typosquatting"],
    hint: "Typosquatting and lookalike domains" },
];

export const ALL_GROUP_KEYS = MODULE_GROUPS.map((g) => g.key);

// Group selection -> the flat id list the scan endpoint expects.
export const idsFor = (groupKeys) =>
  MODULE_GROUPS.filter((g) => groupKeys.includes(g.key)).flatMap((g) => g.ids);

// The seven real result-category names the backend returns, mapped back to a group so
// results can be presented under the same four headings the form used.
const CATEGORY_TO_GROUP = {
  "Email Security": "security",
  "SSL/TLS & HTTPS": "security",
  "Security Headers": "security",
  "Breach & Threat Intelligence": "exposure",
  "Domain & DNS Configuration": "exposure",
  "Infrastructure & Hosting": "infra",
  "Typosquatting & Domain Hijacking Risk": "brand",
  // IP-only scans (a bare IPv4 in the target box) return these instead of the seven
  // above. Unmapped categories are filtered out of the results panel entirely, so
  // without these three rows an IP scan renders as "No findings returned".
  "Public IP Identity & Ownership": "infra",
  "Exposed Services (Public IP)": "infra",
  "TLS Security (Direct IP)": "infra",
  "IP Reputation & Threat Intelligence": "exposure",
};

export const groupForCategory = (name) => CATEGORY_TO_GROUP[name] || null;
